// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CPJt","placeholdersHeader":"styles_placeholdersHeader__26jRX","editorStyle":"styles_editorStyle__r7e0_","placeholdersBox":"styles_placeholdersBox__2xmfv"};